<template>
  <div class="col-12">
      <div class="  row mx-auto">
        <div class="col-md-12">
          <div class="col-md-12">
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-form-label" data-tour-step="1">
                  Judul Broadcast
                  <span class="text text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="broadcastParam.title"
                />
              </div>
            </div>
            <div class="col-md-12" v-if="!broadcastParam.ab_testing_enabled">
              <div class="form-group row">
                <label data-tour-step="2" class="col-form-label">
                  Jenis Pesan
                  <span class="text text-danger">*</span>
                </label>
                <div class="col-12 px-0"> 
                  <a-radio-group @change="checkUpdate"
                    v-model="broadcastParam.message.message_type"
                    size="large"
                  >
                    <a-radio-button value="text">
                      <i class="fa fa-comment"></i>
                      Text Only
                    </a-radio-button>
                    <!-- <a-radio-button v-if="!['image','document'].includes(broadcastParam.message.message_type)" value="media">
                      <i class="fa fa-image"></i>
                      Media
                    </a-radio-button> -->
                    <a-radio-button v-if="broadcastParam.message.message_type !== 'document'" value="image">
                      <i class="fa fa-image"></i>
                      Media
                    </a-radio-button>
                    <a-radio-button v-if="broadcastParam.message.message_type == 'document'" value="document">
                      <i class="fa fa-image"></i>
                      Media
                    </a-radio-button>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="broadcastParam.ab_testing_enabled">
              <div class="alert alert-info py-2 mb-0">
                Jenis pesan diatur per varian pada langkah Content.
              </div>
            </div>
          </div>
          <div class="col-12 info-save-actions">
            <button
              class="btn btn-md btn-rounded waajo-primary-btn info-save-btn"
              type="button"
              @click="update"
            >
              <i class="fa fa-check"></i>
              Simpan Perubahan
            </button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    
  }, 
  computed:{
    broadcastParamSt: {
      get() {
        return this.$store.state.omniwa.broadcastParamSt;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastParamSt", val);
      },
    },
    broadcastStep: {
      get() {
        return this.$store.state.omniwa.broadcastStep;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastStep", val);
      },
    },

  },
  mounted() {
    this.broadcastParam = structuredClone(this.broadcastParamSt); 
  },
  watch:{
    broadcastStep(val){
      if(val == '0'){
        this.broadcastParam = structuredClone(this.broadcastParamSt); 
      }
    }
  },
  data() {
    return {
      messageTypeOptionsSupport: [
        {
          label: "Text Only",
          value: "text",
        },
        {
          label: "Media",
          value: "media",
        },
      ],
      // Default aman agar render pertama tidak mengakses null.
      // Nilai ini akan diganti dengan clone dari store pada mounted().
      broadcastParam: {
        title: "",
        message: {
          message_type: "text",
          text: "",
          file_url: "",
        },
      },
    };
  },
  methods: {
    update() {
        this.broadcastParamSt = structuredClone(this.broadcastParam);
        this.broadcastStep = '';
    },
    checkUpdate(val) {
      console.log(val);
      if (val == "text") {
        this.files = [];
        this.broadcastParam.message.file_url = "";
      }
    },
  },
};
</script>

<style scoped>
.info-save-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-bottom: 4px;
}

.info-save-btn {
  min-width: 150px;
  padding: 9px 20px;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.info-save-btn .fa {
  margin-right: 6px;
}

.waajo-primary-btn {
  background-color: #fe9b44;
  border-color: #fe9b44;
  color: #fff;
}

.waajo-primary-btn:hover,
.waajo-primary-btn:focus {
  background-color: #f08a2e;
  border-color: #f08a2e;
  color: #fff;
}

.waajo-primary-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 575.98px) {
  .info-save-actions {
    display: block;
  }

  .info-save-btn {
    width: 100%;
    min-width: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/form0.vue